import { css } from '@huspy/styled-system/css';

const infoWidgetStyles = {
  container: css({
    borderRadius: 'radius-3',
    backgroundColor: 'bg-tertiary',
    paddingY: 1,
    paddingX: 4,
    height: 'fit-content',
  }),
  titleText: css({
    fontSize: 'md',
    color: 'utility-blue-700',
  }),
  contentText: css({
    fontSize: 'md',
    fontWeight: 'semibold',
    color: 'utility-blue-700',
  }),
};

export default infoWidgetStyles;
